import React, { Component } from "react";
import DatePicker from "react-datepicker";
import moment from "jalali-moment";
import "react-datepicker/dist/react-datepicker.css";
import { Box, SelectBut } from "./style";
moment.locale("fa");

const CustomInput = React.forwardRef(({ value, placeholder, onClick }, ref) => (
  <SelectBut onClick={e => {
    e.preventDefault();
    onClick()
  }} ref={ref}>
    {value !== ""? value : placeholder}
  </SelectBut>
));

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      input_value: this.props.input.value,
      startDate: this.props.input.value
        ? moment(this.props.input.value)
        : moment(),
      selected: this.props.input.value ? moment(this.props.input.value) : null
    };
    this.handleChange = this.handleChange.bind(this);
    this.openDatepicker = this.openDatepicker.bind(this);
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let result = {};
    if (nextProps.input !== prevState.input_value) {
      result.input_value = nextProps.input.value;
      result.startDate = nextProps.input.value
        ? moment(nextProps.input.value)
        : moment();
      result.selected = nextProps.input.value
        ? moment(nextProps.input.value)
        : null;
    }
    return result;
  }

  handleChange(date) {
    this.setState(
      {
        selected: moment(date)
      },
      () => {
        date !== null
          ? this.props.input.onChange(moment(date).format("YYYY/MM/DD"))
          : this.props.input.onChange(moment().format("YYYY/MM/DD"));
      }
    );
  }
  openDatepicker() {
    this._calendar.setOpen(true);
  };
  render() {
    return (
      <Box iconStaus={this.state.iconStaus}>
        {this.props.selectsStart && (
          <DatePicker
            ref={(c) => this._calendar = c}
            placeholderText={this.props.placeholder || "انتخاب تاریخ"}
            openToDate={this.state.startDate}
            selected={this.state.selected}
            onChange={this.handleChange}
            dateFormat="DD MMM YYYY"
            selectsStart
            startDate={moment(this.props.startDate).local("fa")}
            endDate={moment(this.props.endDate).local("fa")}
            name={this.props.name}
            customInput={<CustomInput />}
          />
        )}
        {this.props.selectsEnd && (
          <DatePicker
            ref={(c) => this._calendar = c}
            placeholderText={this.props.placeholder || "انتخاب تاریخ"}
            openToDate={this.state.startDate}
            selected={this.state.selected}
            onChange={this.handleChange}
            dateFormat="DD MMM YYYY"
            selectsEnd
            endDate={moment(this.props.endDate).local("fa")}
            minDate={moment(this.props.minDate).local("fa")}
            name={this.props.name}
            customInput={<CustomInput />}
          />
        )}
        {!this.props.selectsStart && !this.props.selectsEnd && (
          <DatePicker
            ref={(c) => this._calendar = c}
            placeholderText={this.props.placeholder || "انتخاب تاریخ"}
            openToDate={this.state.startDate}
            selected={this.state.selected}
            onChange={this.handleChange}
            dateFormat="DD MMM YYYY"
            name={this.props.name}
            customInput={<CustomInput />}
          />
        )}
        <i onClick={this.openDatepicker} className="calendar-icon icon mapsa-calendar" />
        {this.props.meta.error && this.props.meta.error !== "" && (
          <span className="notice">{this.props.meta.error}</span>
        )}
      </Box>
    );
  }
}

export default Index;
